import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class UploadImageService {
  constructor(private http: HttpClient) {
  }

  upload(file: File): Observable<string> {
    const url = `${environment.backendUrl}/api/v1/image`;
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<string>(url, formData);
  }
}
